<ng-template #dialogClientsInvoices let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="modal-title" style="font-size: 16px">Clients Invoices</h3>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div id="datepicker" class="form-group hide-date">
        <div class="input-group">
          <input name="datepicker" style="display: none;" class="form-control" ngbDatepicker
            [footerTemplate]="footerTemplate" #datepicker="ngbDatepicker" [autoClose]="'outside'"
            (dateSelect)="onDateSelection($event, datepicker)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden"
            [startDate]="fromDate!">
          <ng-template #t let-date="date" let-focused="focused">
            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
              {{ date.day }}
            </span>
          </ng-template>
          <ng-template #footerTemplate>
            <hr class="my-0">
            <button class="btn btn-primary btn-sm m-2 float-left" (click)="lastWeek(); datepicker.close()"
              translate>customer.lastWeek</button>
            <button class="btn btn-secondary btn-sm m-2 float-right" (click)="lastMonth(); datepicker.close()"
              translate>customer.lastMonth</button>
          </ng-template>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6 col-lg-6" style="width: 380px; margin-right: 0;">
          <p style="font-size: .9rem;" translate>customer.from</p>
          <div class="input-group">
            <input #dpFromDate id="fromDate" class="form-control date-input" placeholder="yyyy-mm-dd" name="dpFromDate"
              [ngModel]="formatter.format(fromDate)" (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" style="border: none;" (click)="datepicker.toggle()"
                type="button"></button>
            </div>
          </div>
        </div>
        <div class="form-group col-md-6 col-lg-6" style="width: 380px; margin-right: 0;">
          <p style="font-size: .9rem;" translate>customer.to</p>
          <div class="input-group">
            <input #dpToDate id="toDate" class="form-control date-input" placeholder="yyyy-mm-dd" name="dpToDate"
              [value]="formatter.format(toDate)" (input)="toDate = validateInput(toDate, dpToDate.value)">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary calendar" style="border: none;" (click)="datepicker.toggle()"
                type="button"></button>
            </div>
          </div>
        </div>
        <div class="row mx-3">
          <div class="row my-3">
            <label class="col-12">
              <input type="radio" [(ngModel)]="defaultInvoiceType" value="combo" name="combo" required
                (change)="invoiceConfig($event)"> Combined Invoice Configuration
            </label>
            <label class="col-12">
              <input type="radio" [(ngModel)]="defaultInvoiceType" value="default" name="default" required
                (change)="invoiceConfig($event)"> Default Invoice Confgiruation
            </label>
            <label class="col-12">
              <input type="radio" [(ngModel)]="defaultInvoiceType" value="custom" name="custom" required
                (change)="invoiceConfig($event)"> Custom Invoice Configuration
            </label>
          </div>
        </div>
      </div>
    </form>
    <div *ngIf="clientsInvoices && !clientsInvoices.length" class="text-center my-3">
      No Invoices.
    </div>
    <div  *ngIf="clientsInvoices && clientsInvoices.length && toggleCsvInfo" class="m-3 row d-flex justify-content-center">
      <div class="col-12 text-center">
        <p *ngIf="!csvStillWaiting" translate>invoice.csvIsGenerating</p>
        <p *ngIf="csvStillWaiting" translate>invoice.csvFilesIsGenerating</p>
      </div>
      <div class="button_container btn-invoice" (click)="onLoadInvoices()" [ngbTooltip]="'Refresh'">
        <i class="fa fa-sync-alt"></i>
      </div>
    </div>
    <div *ngIf="clientsInvoices && clientsInvoices.length && !toggleCsvInfo" class="m-3 row d-flex justify-content-center">
      <div class="button_container btn-invoice" (click)="downloadFiles()" [ngbTooltip]="'Download files'">
        <i class="fa fa-download"></i>
      </div>
    </div>
    <button class="custom-button mt-3" (click)="generateCSV()" [disabled]="isGenerating" translate>invoice.generateCsv</button>
  </div>
</ng-template>